export enum MissedEntitiesStatus {
    NOT_DEFINED,
    HAS_ISSUES,
    NO_ISSUES
}
